const localization = {
  nl: {
    title: "Activiteiten",
    hiking: {
      title: "Wandelen",
      p1:
        "Wandelen kunt u vanuit Ferienhaus Vulkaneifel Kopp als de beste. Het huis is niet voor niets ruim 20 jaar in het bezit geweest van een wandelvereniging, Tegenover het huis is een parkeerplaats waar de eerste gemarkeerde wandelingen al staan aangegeven. Daarnaast ligt het huis niet ver van de bekende Eifelsteig.",
      p2:
        "Hier onder een aantal voorbeelden van prachtige routes die u vanuit het huis of vlak in de buurt kunt maken. In het huis liggen plattegronden van deze routes.",
      p3:
        "U kunt uiteraard ook u eigen plan trekken. In het huis liggen wandelkaarten en er hangt een wandelkaart aan de muur. u kunt ook gebruik maken van modernere hulpmiddelen zoals GPS.",
      trails: [
        {
          title: "Wandelroute 1: Eishöhlen (6,5 km)",
          text:
            "Bijna een must, zeker als u met kleinere kinderen bent. Wel een zaklantaarn meenemen, het is donker in de grotten. In het huis liggen enkele helmpjes (maakt het wat echter). De Eishohlen zijn vanuit Birresborn ook per auto bereikbaar. Zo kan iemand die minder goed loopt er toch nog bij zijn. Ook als 6,5 km te veel is kunt u zo de afstand halveren (moet er wel iemand terugrijden)."
        },
        {
          title: "Wandelroute 2: Eigelbacher Maar (8 km of 6,5 km)",
          text:
            "Dit is de route om het drooggevallen kratermeer, het Eigelbacher Maar. Een route met fraaie vergezichten. De route is eenvoudig in te korten tot 6,5 km."
        },
        {
          title: "Wandelroute 3: Weißenseifen (9 km)",
          text:
            "Wandelen door een afwisselend landschap naar het kunstenaarsdorp Weißenseifen. De zuidelijke route is zelfs met de kinderwagen of rolstoel nog goed te doen. In Weißenseifen kan men eventueel iets drinken."
        },
        {
          title: "Wandelroute 4: Mürlenbach (12 km)",
          text:
            "Een wat langere route naar het mooi plaatsje Mürlenbach aan de Kyll. Mürlenbach heeft als bezienswaardigheid de Bertradaburcht. En uiteraard kunt u er wat drinken."
        },
        {
          title: "Wandelroute 5: Schlimmbach (5,6 km)",
          text:
            "Een wandeling langs de beek genaamd Schlimmbach. De wandeling start vanaf een parkeerplaatsen tussen Kopp en Birresborn, maar kan ook gekoppeld worden aan wandeling 1 en / of 2 (als u langere afstanden wilt lopen)."
        },
        {
          title: "Wandelroute 6: Vulkan Kalem (5 km)",
          text:
            "Ten noorden van Birresborn ligt de vulkaan Kalem. Het is een aparte belevenis, waarin de vulkanische elementen duidelijk zichtbaar getoond worden. De wandeling is niet vreselijk moeilijk, maar zeker ook niet gemakelijk te noemen."
        }
      ]
    },
    bicycling: {
      title: "Fietsen",
      p1:
        "Langs de rivieren de Kyll, Prüm en Nims kan men prima uit de weg voor een mooie toertocht. U kunt op en neer rijden langs een rivier (tip begin dan stroomafwaarts, zodat u op de terugweg altijd iets naar beneden fietst). Maar u kunt ook een rondtocht maken, bijvoorbeeld een stuk langs de Kyll en daarna terug via de Prüm of Nims.",
      p2:
        "Houd er wel rekening mee dat als u vanuit het huis vertrekt dat u altijd genoeg energie overhoudt voor het laatste stuk. Het huis ligt op bijna 500 meter hoogte, en het laatste stuk zal u moeten klimmen. Om dit te voorkomen kunt u dus ook met de fietsen op de auto naar een rivier toe te rijden en vanaf daar de fietstocht starten (en eindigen).",
      p3:
        "Ook voor het fietsen kunt u gebruikmaken van GPS, hoewel dat voor een tocht langs een rivier misschien wat minder interessant is. Maar op deze site vindt u ook langere en pittige routes waarbij u meer mag klimmen en dalen.",
      p4:
        "Heb u problemen met de fiets? 4 Kilometer verderop in het plaatsje Birresborn zit een grote fietsenzaak, waar overigens ook fietsen gehuurd kunnen worden."
    },
    bicycleRacing: {
      title: "Wielrennen",
      p1:
        "In de Eifel kunt u uzelf helemaal uitleven op de vele wegen die het gebied doorkruizen. Fiets van dal tot dal en u weet zeker dat u de avond goed zal slapen. En heb u pech met u fiets, of heb u extra spullen nodig? Op slechts 4 kilometer van het huis, in Birresborn, vindt u een moderne fietsenzaak die u vooruit kan helpen en van alle advies kan voorzien.",
      p2:
        'Voor een flinke tocht door de heuvel kan het wel erg gemakkelijk zijn om gebruik te maken van GPS. De echte cracks maken hier waarschijnlijk al volop gebruik van, maar bij deze toch maar een verwijzing naar een site die we zelf vaak gebruiken: <a href="http://www.gpsies.com/" target="_blank" rel="noopener noreferrer">GPSies</a>.'
    },
    mountainBiking: {
      title: "Mountainbiken",
      p1:
        "Het is fantastisch mountainbiken in de heuvels rond Kopp. Maar de meeste mountainbike-routes beginnen vanuit het 4 kilometer verderop gelegen Birresborn. In Birresborn is ook een moderne fietsenzaak waar u terecht kunt voor reparaties en allerlei accessoires. Ook kunt u daar fietsen huren.",
      p2:
        "En ook hier geldt dat GPS een handig hulpmiddel is. Een aantal van de tochten komt vlak langs het huis in Kopp."
    },
    kayaking: {
      title: "Kajakken",
      p1:
        "In de omgeving van Kopp zijn binnen een straal van 50 km wel 11 rivieren te vinden (sommigen hebben meerdere trajecten). De moeilijkheidsgraad varieert van WW I tot en met WW IV (en daarboven bij hoog water). Op de terugweg naar Nederland kunt u mooi de Rur bij Monschau meepakken.",
      p2:
        "Het varen is echter wel afhankelijk van een goede waterstand. Met name zwaardere trajecten (WW III tot en met IV) hebben voldoende water nodig, en zullen vaak pas bevaarbaar zijn van het late najaar tot het vroege voorjaar. De trajecten met WW I tot en met II zullen wat langer bevaarbaar zijn. In de zomer staan de meeste rivieren te droog om nog van kajakken te kunnen spreken.",
      rivers: [
        { title: "Rivier 1: Rur", class: "II - IV" },
        { title: "Rivier 2: Alfbach", class: "I+ - III+" },
        { title: "Rivier 3: Elzbach", class: "I - II" },
        { title: "Rivier 4: Endertbach", class: "II - IV" },
        { title: "Rivier 5: Irsenbach", class: "I - II" },
        {
          title: "Rivier 6: Kleiner Kyll",
          class: "II+",
          text: "1 Passage III - IV afhankelijk van de waterstand."
        },
        { title: "Rivier 7: Kyll", class: "I", text: "Beginnersrivier." },
        {
          title: "Rivier 8: Lieser",
          class: "I - II",
          text: "Leuk voor beginners tot middelmatige waterstand."
        },
        {
          title: "Rivier 9: Nims",
          class: "I - II",
          text: "Met de laatste 3 km klasse III bij hoog water."
        },
        {
          title: "Rivier 10: Enzbach",
          class: "I+",
          text: "Met een leuk verval in Neuerburg."
        },
        {
          title: "Rivier 11: Prüm",
          class: "II - IV",
          text: "Irreler Wasserfalle."
        },
        {
          title: "Rivier 12: Ussbach",
          class: "I - III",
          text: "Grootste gedeelte klasse I - II."
        },
        {
          title: "Rivier 13: Ahr",
          class: "I+",
          text: "Geschikt voor beginners en open kano's  Canadezen."
        }
      ]
    },
    rockClimbing: {
      title: "Klimmen",
      p1:
        "In Gerolstein liggen de Gerolsteiner Dolomieten. Klimmen is toegestaan op de klimwand Hustley. Er is echter een vergunning nodig om hier te mogen klimmen. Deze vergunning kan men afhalen bij het toeristenbureau in het centrum van Gerolstein (in het station). De kosten zijn €5,00 per dag (prijs 2016)."
    },
    winterSports: {
      title: "Skiën en Langlaufen",
      p1:
        "In de Eifel valt helaas niet zo vaak sneeuw. Maar als er sneeuw valt gaan er in de Eifel diverse pistes open. De dichtstbijzijnde pistes vanuit Kopp zijn Wolfsshlucht Prüm (21 km), Daun (31 km) en Schwarzer Mann (34 km).",
      p2:
        "Als er sneeuw ligt kunt u rondom Kopp prima langlaufen als u zelf u spoor trekt. Omdat Kopp vrij hoog ligt (500m) zal u er eerder sneeuw tegenkomen dan in de dalen. Zoek u liever een loipe op, dan kun u daarvoor naar de bovengenoemde ski-gebieden of de volgende plaatsen:",
      tracks: [
        "Blankenheim (35 km)",
        "Nettersheim (47 km)",
        "Weißer Stein (49 km)",
        "Hollerath (51 km)",
        "Bad Münstereifel (66 km)"
      ],
      p3:
        'Meer informatie over wintersport in de Eifel vindt u op <a href="https://www.eifel.info/ausflugsziele/aktivitaeten/winter-schnee/skigebiete" target="_blank" rel="noopener noreferrer">deze website</a>.'
    },
    golf: {
      title: "Golfen",
      p1:
        'Niet ver van Kopp liggen twee golfbanen. <a href="http://www.golfclub-eifel.de/" target="_blank" rel="noopener noreferrer">Golfclub Eifel</a> ligt vlak bij Hillesheim iets ten noorden van Gerolstein (23 km van Kopp). <a href="http://www.golf-lietzenhof.de/" target="_blank" rel="noopener noreferrer">Golfanlage Lietzenhof</a> ligt ten zuidwesten van Kopp (19 km).',
      p2:
        "Kijk op de betreffende website van beide verenigingen voor meer en up-to-date informatie."
    },
    archery: {
      title: "Boogschieten",
      p1:
        'In Kopp zelf kunt u boogschieten bij het <a href="https://www.wolffhotel.de/" target="_blank" rel="noopener noreferrer">Wolffhotel</a>. Wel vooraf even afstemmen met de hoteleigenaar als je zin hebt om te gaan boogschieten..'
    },
    motorCycling: {
      title: "Motorrijden",
      p1:
        "De Eifel is een favoriet gebied voor motorrijders. Wil u echt snel? De Nürburgring ligt op slechts 44 kilometer van Kopp. Zorg er wel voor dat u weer heel in Kopp terug komt!"
    }
  },
  de: {
    title: "Aktivitäten",
    hiking: {
      title: "Wandern",
      p1:
        "Wandern können Sie ab Ferienhaus Vulkaneifel Kopp überall. Dazu war das Haus mehr als 20 Jahren im Besitz eines Wandervereins. Vor dem Haus befindet sich ein Parkplatz, wo die ersten Wanderwegen bereits markiert sind. Darüber hinaus liegt das Haus nicht weit von dem berühmten Eifelsteig. Zum Beispiel kann eine Anzahl von Routen, die kann von Ihnen aus dem Haus oder in der Nähe nehmen.",
      p2:
        "Hier unten siend einige Beispiele für schöner Routen die Sie aus dem Hause oder in der Nähe stattfinden können. Im Haus gibt es Karter dieser Routen.",
      p3:
        "Im Haus befinden sich Karten dieser Routen. Natürlich können Sie Ihre eigenen Plan ziehen. Im Haus sind Wanderkarten und es gibt eine Wanderkarte an der Wand. Sie können auch moderne Werkzeuge benutzen wie GPS.",
      trails: [
        {
          title: "Wanderroute 1: Eishöhlen (6,5 km)",
          text:
            "Fast ein Muss, vor allem wenn Sie mit kleinen Kindern sind. Sie sollen eine Taschenlampe mitbringen, es ist dunkel in die Hohle. Im Haus sind einige Helme (macht es echt). Die Eishöhlen sind auch mit dem Auto erreichbar von Birresborn. So können schlechtere Läufer auch dabei sein. Auch ist es so möglich die Abstand zu halbieren (aber dann muss jemand zurückfahren)."
        },
        {
          title: "Wanderroute 2: Eigelbacher Maar (8 km ob 6,5 km)",
          text:
            "Dies ist der Weg rundherum die trockengefallen Kratersee, das Eigelbacher Maar. Eine Route mit schöner Aussichten."
        },
        {
          title: "Wanderroute 3: Weißenseifen (9 km)",
          text:
            "Ein Spaziergang durch das abwechslungsreiche Landschaft nach das Künstlerdorf Weißenseifen. Die südliche Route ist auch mit einem Kinderwagen oder Rollstuhl machbar. In Weißenseifen kann man etwas trinken."
        },
        {
          title: "Wanderroute 4: Mürlenbach (12 km)",
          text:
            "Eine etwas längere Strecke zu dem schönen Dorf Mürlenbach an der Kyll. Mürlenbach hat die Sehenswürdigkeit Bertradaburcht. Und natürlich können Sie in das Dorf etwas trinken."
        },
        {
          title: "Wanderroute 5: Schlimmbach (5,6 km)",
          text:
            "Ein Spaziergang entlang des Baches genannt Schlimmbach. Die Wanderung beginnt von einem Parkplatz zwischen Kopp und Birresborn, kann aber auch verknüpft werden mit Route 1 und/oder 2 (wenn Sie längere Strecken laufen möchte)."
        },
        {
          title: "Wanderroute 6: Vulkan Kalem (5 km)",
          text:
            "Nördlich von Birresborn liegt der Vulkan Kalem. Es ist eine ungewöhnliche Erfahrung, bei der die vulkanische Elemente deutlich sichtbar dargestellt sind. Der Weg ist nicht sehr schwierig, aber sicherlich auch nicht einfach."
        }
      ]
    },
    bicycling: {
      title: "Radfahren",
      p1:
        "Entlang die Flüsse Kyll, Prüm und Nims kann man sehr schön radfahren. Entlang die Flüsse Kyll, Prüm und Nims kann man sehr gut einen schönen Tour machen mit dem fahrrad. Sie können nach oben und nach unten an einem Fluss entlang fahren (stromabwärts anfangen, da der Rückweg weniger steigt). Sie können aber auch eine Rundreise machen, zum Beispiel ein Stück entlang der Kyll und dann zurück entlang die Prüm oder Nims.",
      p2:
        "Denken Sie daran, dass wenn Sie das Haus verlassen, dass Sie immer genug Energie für das letzte Stück zurück behalten. Das Haus ist fast 500 Meter hoch, und das letzte Teil geht immer steil hinauf. Um dies zu verhindern, können Sie auch mit dem Fahrrad auf (oder in) das Auto zum Fluss fahren und von dort mit dem Fahrrad starten (und enden).",
      p3:
        "Für das Radfahren können Sie auch GPS nutzen. Fúr eine Tour entlang einen Fluss ist GPS vielleicht weniger interessant. Aber auf dieser Website finden Sie auch andere lange und schwierige Strecken, wo man mehr klettern und absteigen kann.",
      p4:
        "Und haben Sie Probleme mit dem Fahrrad? 4 Kilometer entfernt in der Stadt Birresborn ist ein großes Fahrradgeschäft, wo auch Fahrräder repariert und vermietet werden."
    },
    bicycleRacing: {
      title: "Radrennfahren",
      p1:
        "Radeln Sie sich selbst völlig leer gegen die steilen Krater der Vulkaneifel. In der Eifel können Sie genießen auf den vielen Straßen die das Gebiet durchqueren. Bike von Tal zu Tal, und Sie sind sicher dass Sie sehr gut schlafen. Und haben Sie Panne mit dem Fahrrad, oder benötigen Sie zusätzliche Sachen? Nur 4 km vom Haus entfernt, in Birresborn, finden Sie einen modernen Fahrradgeschäft, der Sie gerne weiter hilft.",
      p2:
        'Für eine große Tour durch die Hügel kann es praktisch sein sich zu bedienen mit ein GPS. Die wirkliche Fanatiker nutzen wahrscheinlich bereits GPS. Aber für den der das neu ist, gucken Sie zum beispiel mal auf dem website <a href="http://www.gpsies.com/" target="_blank" rel="noopener noreferrer">GPSies</a>.'
    },
    mountainBiking: {
      title: "Mountainbiken",
      p1:
        "Es ist fantastisch Mountainbiken in den Hügeln rund um Kopp. Aber die meisten Mountainbike-Routen beginnen in der 4 km weiter gelegen Birresborn. Dort ist auch ein modernes Fahrradgeschäft, wo man hin gehen kann für Reparaturen und allerhande Zubehören. Sie können dort auch Fahrräder mieten.",
      p2:
        "Und auch hier ist GPS ein praktisches Werkzeug. Einige der Touren kommen an Kopp vorbei."
    },
    kayaking: {
      title: "Kajakfahren",
      p1:
        "Rund Kopp gibt es in einem Umkreis von 50 km 11 Flüsse zum kajakfahren (oft mit mehrere Strecken). Die Schwierigkeit liegt im Bereich von WW1 zu WW4 (und daruber beim hohes Wasser). Ein bisschen weiter liegt die schöne Rur in Monschau.",
      p2:
        "Kajakfahren in dieser Gegend ist von gutes Wasser abhängig. Bemerkenswert schwerer Abschnitte (WW III-IV) müssen ausreichend Wasser haben und sind oft nur vom Spätherbst bis Frühjahr befahrbar. Die Strecken mit WW I-II werden ein wenig länger befahrbar sein. Die meiste Flüsse sind im Sommer zu trocken um Kajakfahren zu können. Dan kann man vielleicht noch nach die Sure gehen (Grenze Luxembourg).",
      rivers: [
        { title: "Fluss 1: Rur", class: "II - IV" },
        { title: "Fluss 2: Alfbach", class: "I+ - III+" },
        { title: "Fluss 3: Elzbach", class: "I - II" },
        { title: "Fluss 4: Endertbach", class: "II - IV" },
        { title: "Fluss 5: Irsenbach", class: "I - II" },
        {
          title: "Fluss 6: Kleiner Kyll",
          class: "II+",
          text: "1 Durchgang Klasse III - IV von Wasserstand abhängig."
        },
        { title: "Fluss 7: Kyll", class: "I", text: "Anfänger Fluss." },
        {
          title: "Fluss 8: Lieser",
          class: "I - II",
          text: "Schöner Fluss für Anfänger bis mäßig Wasser."
        },
        {
          title: "Fluss 9: Nims",
          class: "I - II",
          text: "Klasse III in den letzten 3 km mit Hochwasser."
        },
        {
          title: "Fluss 10: Enzbach",
          class: "I+",
          text: "Aber ein schöner Wasserfal in Neuerburg."
        },
        {
          title: "Fluss 11: Prüm",
          class: "II - IV",
          text: "Irreler Wasserfalle."
        },
        {
          title: "Fluss 12: Ussbach",
          class: "I - III",
          text: "Allgemein Klasse I - II."
        },
        {
          title: "Fluss 13: Ahr",
          class: "I+",
          text: "Geeignet für Anfänger und Canadian Kanu."
        }
      ]
    },
    rockClimbing: {
      title: "Klettern",
      p1:
        "In Gerolstein findet man die Gerolsteiner Dolomiten. Klettern ist auf der Kletterwand Hustley erlaubt. Man braucht ein Erlaubnis um hier zu klettern. Diese Erlaubnis kann man im Touristeninformation im Bahnhofsgebäude in der Stadt Gerolstein bekommen. Die Kosten betragen € 5,00 pro Tag (Preise 2016)."
    },
    winterSports: {
      title: "Skifahren und Langlaufen",
      p1:
        "In der Eifel gibt es leider nicht oft Schnee. Aber wenn es Schnee gibt, sind mehrere Skipisten geöffnet. Die nächste Pisten von Kopp sind Wolfsshlucht Prüm (21 km), Daun (31 km) und Schwarzer Mann (34 km).",
      p2:
        "Wenn es Schnee gibt, können Sie tatsächlich überall Langlaufen in der Eifel. Da Kopp ziemlich hoch liegt (500m) gibt es eher Schnee dann unter in den Tälern. Wenn es Schnee gibt kann man tatsächlich überall rundherum Kopp Langlaufen. Bevorzugen Sie eine Loipe, dann können Sie dafur zu den nahe gelegenen Skigebieten gehen.",
      tracks: [
        "Blankenheim (35 km)",
        "Nettersheim (47 km)",
        "Weißer Stein (49 km)",
        "Hollerath (51 km)",
        "Bad Münstereifel (66 km)"
      ],
      p3:
        'Für weitere Information sehen Sie <a href="http://www.eifel.info/skigebieden-eifel.htm" target="_blank" rel="noopener noreferrer">diese Website</a>.'
    },
    golf: {
      title: "Golf spielen",
      p1:
        'In der Nähe von Kopp sind zwei schöne Golfplätze. <a href="http://www.golfclub-eifel.de/" target="_blank" rel="noopener noreferrer">Golfclub Eifel</a> ist in der Nähe von Hillesheim, nördlich von Gerolstein (23 km von Kopp). <a href="http://www.golf-lietzenhof.de/" target="_blank" rel="noopener noreferrer">Golfanlage Lietzenhof</a> liegt im Südwesten von Kopp (19 km).',
      p2: "Weitere Information finden Sie auf der Website der beiden Verbände."
    },
    archery: {
      title: "Bogenschießen",
      p1:
        'Nur eine Kilometer von das Haus kann mann Bogenschießen In Kopp beim <a href="https://www.wolffhotel.de/" target="_blank" rel="noopener noreferrer">Wolffhotel</a>. Bitte vorher das hotel anrufen zu fragen ob es möglich ist (es muss passen in Ihren Schema).'
    },
    motorCycling: {
      title: "Motorradfahren",
      p1:
        "Die Eifel ist ein beliebtes Gebiet für Motorradfahrer . Wollen Sie wirklich schnell fahren? Der Nürburgring ist nur 44 Kilometer von Kopp. Aber stellen Sie sich sicher, dass Sie wieder ganz und gar in Kopp zuruck kommen!"
    }
  },
  en: {
    title: "Activities",
    hiking: {
      title: "Hiking",
      p1:
        "Ferienhaus Vulkaneifel Kopp is the perfect starting point for your hikes. The house wasn't in the possession of a hiking club for more than 20 years for no reason. Opposite the house you will find the route markers. In addition, the house is not far from the famour Eifelsteig.",
      p2:
        "Below you will find some examples of beautiful trails that you can make. They all start right at the front door or nearby.",
      p3:
        "Of course, you are free to make your own trails. You will find maps in the house and there is a large hiking map on one of the walls. You can also use more modern tools such as GPS.",
      trails: [
        {
          title: "Hiking trail 1: Eishöhlen (6.5 km)",
          text:
            "Almost a must, especially if you are with smaller children. Bring a flashlight, it's dark in the caves. We have some helmets available in the house to somewhat enhance the experience. The Eishohlen can also be reached by car from Birresborn. If 6.5 km is still too far for some people in your group, you can easily halve the route but someone will have to drive back by car."
        },
        {
          title: "Hiking trail 2: Eigelbacher Maar (8 km or 6.5 km)",
          text:
            "A trail circling the dry crater lake Eigelbacher Maar with spectecular views. The route can easily be shortened to 6.5 km."
        },
        {
          title: "Hiking trail 3: Weissenseifen (9 km)",
          text:
            "Hiking through a varied landscape to the artistic village of Weißenseifen. This trail can even be completed with a pram or wheelchair. There are some establishments where you can have a break and a drink in Weißenseifen"
        },
        {
          title: "Hiking trail 4: Mürlenbach (12 km)",
          text:
            "A longer trail that leads to the beautiful town of Mürlenbach on t he Kyll. Mürlenbach has the Betradaburcht attraction and of course you can have a break and drink something here as well."
        },
        {
          title: "Hiking trail 5: Schlimmbach (5.6 km)",
          text:
            "Hike along a stream called Schlimmbach. The trail starts at a parking lot between Kopp and Birresborn and can be connected to trail 1 and/or 2 if you want to hike a longer distance."
        },
        {
          title: "Hiking trail 6: Vulkan Kalem (5 km)",
          text:
            "The vulcano Kalem is located north of Birresborn. Seeing the clearly visible volcanic elements is an extraordinary experience. The trail isn't particularly long but still quite difficult."
        }
      ]
    },
    bicycling: {
      title: "Bicycling",
      p1:
        "One can easily make a nice tour along the rivers Kyll, Prüm and Nims. You can ride up and down one of these rivers (tip: start downstream so that you always ride downhill on your way back), or ride along one river and circle back by following another.",
      p2:
        "Do keep in mind that the house is located at an altitude of almost 500 meters which means you'll have to climb the last leg of your ride. Alternatively, you can take your bicycles down to the river by car and start and end there.",
      p3:
        "You can also use GPS. Although this is not very useful for rides along a river, it can be helpful for the longer and more difficult rides.",
      p4:
        "There is a large bicycle shop in the nearby village of Birresborn (4 km) where you can go if you are having technical difficulties or to rent bicycles."
    },
    bicycleRacing: {
      title: "Bicycle racing",
      p1:
        "You can go wild on one of the many roads that cross the area. A ride accross the valleys and an early night due to exhaustion is ensured. There is a modern bicycle shop in the nearby village of Birresborn (4 km) where you can go for gear, advice or repairs.",
      p2:
        'A GPS can be a very useful tool for longer rides. Here is a link to a site we like to use: <a href="http://www.gpsies.com/" target="_blank" rel="noopener noreferrer">GPSies</a>.'
    },
    mountainBiking: {
      title: "Mountain biking",
      p1:
        "Mountain biking is fantastic in the hills around Kopp. However, the most trails by far start in the nearby village of Birresborn (4 km from Kopp). In Birresborn you will also find a modern bicycle shop where you can go for repairs, gear and to rent equipment.",
      p2:
        "Also for mountain biking GPS can be a very handy tool. Some of the trails pass right in front of the house in Kopp."
    },
    kayaking: {
      title: "Kayaking",
      p1:
        "Within a radius of 50 km around Kopp you will find 11 different rivers. The difficulty levels from class 1 to 4 (and even higher with high water levels). To the northwest you will find the Rur at Monschau.",
      p2:
        "Of course, whitewater kayaking is dependent on a decent water level which means that - and this is especially true for the higher class tracts - some of these rivers are only navigable from late autumn to early spring. During the summer the water levels in most rivers is simply too low to go kayaking.",
      rivers: [
        { title: "River 1: Rur", class: "II - IV" },
        { title: "River 2: Alfbach", class: "I+ - III+" },
        { title: "River 3: Elzbach", class: "I - II" },
        { title: "River 4: Endertbach", class: "II - IV" },
        { title: "River 5: Irsenbach", class: "I - II" },
        {
          title: "River 6: Kleiner Kyll",
          class: "II+",
          text: "1 Passage III - IV depending on the water level."
        },
        { title: "River 7: Kyll", class: "I", text: "Beginner's river." },
        {
          title: "River 8: Lieser",
          class: "I - II",
          text: "Fun for beginners up to a moderate water level."
        },
        {
          title: "River 9: Nims",
          class: "I - II",
          text: "With the last 3 km being class III at high water levels."
        },
        {
          title: "River 10: Enzbach",
          class: "I+",
          text: "With a nice decline in Neuerburg."
        },
        {
          title: "River 11: Prüm",
          class: "II - IV",
          text: "Irreler Wasserfalle."
        },
        {
          title: "River 12: Ussbach",
          class: "I - III",
          text: "Though mostly class I - II."
        },
        {
          title: "River 13: Ahr",
          class: "I+",
          text: "Suitable for beginners and canoes."
        }
      ]
    },
    rockClimbing: {
      title: "Rock climbing",
      p1:
        "In Gerolstein you will find the Gerolsteiner Dolomites. Climbing is permitted on the climbing wall Hustley, however, a permit is required to be allowed to climb here. This permit can be purchased at the tourist office in the center of Gerolstein (in the train station) for € 5.00 per day (price 2016)."
    },
    winterSports: {
      title: "Skiing and Cross-Country skiing",
      p1:
        "Unfortunately, we don\t have much snowfall in the Eifel. When there is snow, however, several pistes open in the Eifel. The pistest nearest to Kopp are Wolfsshlucht Prüm (21 km), Daun (31 km) and Schwarzer Mann (34 km).",
      p2:
        "You can easily go cross-country ski if there is snow and you create your own trail. Due to Kopp's high altitude, you will find snow here more easily than you will in the valleys. If you prefer to ski on an existing trail, you can go to one of the following places:",
      tracks: [
        "Blankenheim (35 km)",
        "Nettersheim (47 km)",
        "Weißer Stein (49 km)",
        "Hollerath (51 km)",
        "Bad Münstereifel (66 km)"
      ],
      p3:
        'Additional information about winter sports in the Eifel can be found on <a href="http://www.eifel.info/skigebieden-eifel.htm" target="_blank" rel="noopener noreferrer">this website</a>.'
    },
    golf: {
      title: "Golf",
      p1:
        'There are two golf courses not far from Kopp. <a href="http://www.golfclub-eifel.de/" target="_blank" rel="noopener noreferrer">Golfclub Eifel</a> is located near Hillesheim, just north of Gerolstein (23 km from Kopp). <a href="http://www.golf-lietzenhof.de/" target="_blank" rel="noopener noreferrer">Golfanlage Lietzenhof</a> is located to the southwest of Kopp (19 km).',
      p2: "See the websites of these clubs for more information."
    },
    archery: {
      title: "Archery",
      p1:
        'You can practice archery at the nearby <a href="https://www.wolffhotel.de/" target="_blank" rel="noopener noreferrer">Wolffhotel</a>. Please coordinate with the hotel owner in advance.'
    },
    motorCycling: {
      title: "Motorcycling",
      p1:
        "The Eifel is a favourite to many motorcyclists. If you really want to go fast, the Nürnburgring is only 44 km from Kopp. Just make sure you return in one piece!"
    }
  }
};

export default localization;



// WEBPACK FOOTER //
// ./src/localization/activities.js